/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelsCountByCountryResponse } from '../../models/travels-count-by-country-response';

export interface TravelControllerCountByCountries$Params {
}

export function travelControllerCountByCountries(http: HttpClient, rootUrl: string, params?: TravelControllerCountByCountries$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelsCountByCountryResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerCountByCountries.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelsCountByCountryResponse;
      }>;
    })
  );
}

travelControllerCountByCountries.PATH = '/travel/count-by-country';
